/**
 * Copyright © Veeam Software Group GmbH.
 */

import { useContext } from 'react';

import { ProductContext } from '../contexts';

export const useProductStore = () => useContext(ProductContext);
